document.addEventListener("DOMContentLoaded", function () {
  const element = document.querySelector(".content-for-layout");

  function stickyInfoOnPage() {
    if (!element) return;

    const productInfo = element.querySelector(".product-grid__item--content-wrapper");
    const productGallery = element.querySelector(".product-grid__item--media");
    const mainProduct = element.querySelector(".main-product");

    const sectionsAfterProductInfo = [];
    let nextElement = mainProduct.nextElementSibling;
    while (nextElement) {
      sectionsAfterProductInfo.push(nextElement);
      nextElement = nextElement.nextElementSibling;
    }

    const pageOffsetTop = element.offsetTop;
    const headerHeight = document.querySelector(".header").offsetHeight;
    let pageOffsetBottom = sectionsAfterProductInfo[sectionsAfterProductInfo.length - 1].offsetTop + sectionsAfterProductInfo[sectionsAfterProductInfo.length - 1].offsetHeight;

    const productRecommendationsSection = element.querySelector(".section--product-recommendations");

    if (productRecommendationsSection) {
      pageOffsetBottom -= (productRecommendationsSection.offsetHeight * 1.5);
    }
    
    const pageHeight = document.body.scrollHeight

    const stickyInfoOnPageHandler = () => {
      if (window.innerWidth >= 750) {
        const scrollY = window.scrollY;
        const productInfoHeight = productInfo.offsetHeight;
        const productInfoLeftPosition = productGallery.getBoundingClientRect().right;
        const productContentStart = document.querySelector('.product__content--start'); 
        const productContentStartPosition = productContentStart.getBoundingClientRect().top; 
        const headerHeight = document.querySelector(".header").offsetHeight;
        let stickyStartPosition = productInfo.getBoundingClientRect().top + window.scrollY - headerHeight;

        const footer = document.querySelector('.footer')
        let footerHeight = footer.offsetHeight;
        const footerTop = footer.getBoundingClientRect().top;
        const productFeedSection = document.querySelector(".product-feed");
        let calculatedHeight = pageOffsetTop + (footerHeight * 2) + productInfoHeight + element.offsetTop + scrollY
        const targetOffsetTop = productFeedSection ? productFeedSection.offsetTop : footer.offsetTop;
        const productGrid = document.querySelector('.product-grid');
        const computedStyle = getComputedStyle(productGrid);
        const gapValue = computedStyle.getPropertyValue('gap');
        const gapValueNumber = parseInt(gapValue, 10);

        if (productFeedSection) {
          const productFeedHalfwayPoint = targetOffsetTop + productFeedSection.offsetHeight / 2;
          if (scrollY + productInfoHeight + 50 >= productFeedHalfwayPoint) {
            productInfo.style.opacity = "0";
            productInfo.classList.remove('scrolled');
            productInfo.style.zIndex = "0"
          } else {
            productInfo.style.opacity = "1";
            productInfo.style.zIndex = "2"
          }
          if (window.scrollY >= stickyStartPosition) {
            productInfo.style.position = "fixed";
            productInfo.classList.add('scrolled');
            productInfo.style.top = `${headerHeight + 10}px;`
            productInfo.style.left = `${productInfoLeftPosition + gapValueNumber}px`;
            productInfo.style.right = "36px"; 
          } 
        } else {
          if (footerTop <= window.innerHeight - productInfoHeight/2) {
            productInfo.style.opacity = "0";
            productInfo.classList.remove('scrolled');
            productInfo.style.zIndex = "0"
          } else {
            productInfo.style.opacity = "1";
            productInfo.style.zIndex = "2"
          }
          if (window.scrollY >= stickyStartPosition) {
            productInfo.style.position = "fixed";
            productInfo.classList.add('scrolled');
            productInfo.style.top = `${headerHeight + 10}px;`
            productInfo.style.left = `${productInfoLeftPosition + gapValueNumber}px`;
            productInfo.style.right = "36px"; 
          } 
        }

        if (productRecommendationsSection) {
          calculatedHeight += productRecommendationsSection.offsetHeight;
        }
        
        if (scrollY >= pageOffsetTop && scrollY + productInfoHeight <= pageOffsetBottom && pageOffsetBottom > calculatedHeight) {
          productInfo.style.position = "fixed";
          productInfo.style.top = `${headerHeight + 10}px;`
          productInfo.style.left = `${productInfoLeftPosition + gapValueNumber}px`;
          productInfo.style.right = "36px"; 
        } else if (scrollY < pageOffsetTop - headerHeight) {
          productInfo.style.position = "static";
          productInfo.classList.remove('scrolled');
        }
      } else { 
        productInfo.style.position = "static";
        productInfo.classList.remove('scrolled');
      }
    };

    const reCalculateSectionsWidths = () => {
      if (window.innerWidth >= 750) {
        const productGalleryWidth = productGallery.offsetWidth;
        sectionsAfterProductInfo.forEach((section) => {
          if (!section.classList.contains("section--product-recommendations")) {
            section.style.width = `${productGalleryWidth}px`;
            section.style.marginInlineStart = "36px";
            section.style.setProperty("--container-padding", "0");
          }
        });
      } else { 
        sectionsAfterProductInfo.forEach((section) => {
          section.style.width = ""; 
          section.style.marginInlineStart = "";
          section.style.removeProperty("--container-padding");
        });
      }
    };

    window.addEventListener("scroll", () => {
      stickyInfoOnPageHandler();
    });
    window.addEventListener("load", () => {
      reCalculateSectionsWidths();
      stickyInfoOnPageHandler();
    });
    window.addEventListener("resize", () => {
      reCalculateSectionsWidths();
      stickyInfoOnPageHandler();
    });
  }

  stickyInfoOnPage();

  const stickyProductInfo = document.querySelector(".product__content--start.sticky-product-info");

  if (stickyProductInfo) {
    stickyProductInfo.addEventListener("wheel", function (e) {
      e.stopPropagation();
  
      const scrollSpeed = 4;
      const scrollAmount = e.deltaY * scrollSpeed;
  
      const atTop = stickyProductInfo.scrollTop === 0;
      const atBottom = stickyProductInfo.scrollHeight - stickyProductInfo.scrollTop === stickyProductInfo.clientHeight;
  
      if ((e.deltaY < 0 && atTop) || (e.deltaY > 0 && atBottom)) {
        e.preventDefault();
        window.scrollBy({
          top: scrollAmount,
          behavior: "auto"
        });
      }
    }, { passive: false });
  }
});
